import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { api, formatApiError } from "@/lib/api";
import { Logo } from "@/components/Logo";

export default function DocumentView() {
  const { docId } = useParams();
  const [src, setSrc] = useState("");
  const [error, setError] = useState("");
  useEffect(() => {
    api.get(`/documents/${docId}/download`, { responseType: "blob" }).then((r) => setSrc(URL.createObjectURL(r.data))).catch((e) => setError(formatApiError(e)));
  }, [docId]);
  return (
    <div className="flex min-h-screen flex-col bg-brand-ivory" data-testid="document-view-page">
      <header className="flex h-16 items-center justify-between border-b border-brand-line bg-white px-6"><Link to="/"><Logo /></Link><Link to="/dashboard" className="text-sm font-semibold text-brand-blue" data-testid="document-back-link">Back to dashboard</Link></header>
      {error ? <p className="p-10 text-center text-sm text-red-600" data-testid="document-error">{error}</p> : src ? <iframe title="document" src={src} className="flex-1" data-testid="document-frame" /> : <p className="p-10 text-center text-sm text-brand-slate">Loading document…</p>}
    </div>
  );
}
